export default "__VITE_ASSET__CelzL1kS__"